import axios from "@/components/api/axios";

const get = async request => {
    return await axios.post(
        '/dashboard/get',
        request).then(response => response.data)
}

export default {
    get,
}